module.exports = __webpack_public_path__ + "img/大数据.693b9f85.png";